import request from '@/utils/request'

let GtaskApi = {

  /*任务列表*/
  list(data) {
    return request._post('/shop/plus.gtask.Index/index', data);
},
gtaskListx(data) {
    return request._post('/shop/plus.gtask.Index/indexx', data);
},
/*添加任务*/
add(data) {
    return request._post('/shop/plus.gtask.Index/add', data);
},
/*修改任务*/
edit(data) {
    return request._post('/shop/plus.gtask.Index/edit', data);
},
/*删除任务*/
del(data) {
    return request._post('/shop/plus.gtask.Index/del', data);
},
/*任务详情*/
detail(data) {
  return request._post('/shop/plus.gtask.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.gtask.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.gtask.Setting/getSetting', data, errorback);
    },
}
export default GtaskApi;



// WEBPACK FOOTER //
// ./src/api/gtask.js